// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n#AuditTrail-page{\r\n    height: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n#AuditTrail-page .filter-wrapper + .table{\r\n    height: calc(100% - (20px + 125px)) !important;\r\n}", ""]);
// Exports
module.exports = exports;
